var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-input-wrapper", class: { "inline-input": _vm.inline } },
    [
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "c-input-label",
              class: _vm.labelClass,
              attrs: { for: _vm.id },
            },
            [
              _vm._v("\n        " + _vm._s(_vm.label)),
              _vm.required ? [_vm._v("*")] : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          class: {
            "input-group": !!_setup.slot.append || !!_setup.slot.prepend,
          },
        },
        [
          _setup.slot.prepend
            ? _c(
                "div",
                { staticClass: "input-group-prepend border" },
                [_vm._t("prepend")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.computedType === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.model,
                    expression: "model",
                  },
                ],
                ref: "inputRef",
                staticClass: "form-control",
                class: _setup.computedClass,
                attrs: {
                  id: _vm.id,
                  name: _vm.name,
                  disabled: _vm.disabled,
                  placeholder: _vm.placeholder,
                  required: _vm.required,
                  minlength: _vm.minlength,
                  maxlength: _vm.maxlength,
                  step: _vm.step,
                  min: _vm.min,
                  max: _vm.max,
                  pattern: _vm.pattern,
                  type: "checkbox",
                },
                domProps: {
                  checked: Array.isArray(_setup.model)
                    ? _vm._i(_setup.model, null) > -1
                    : _setup.model,
                },
                on: {
                  blur: function ($event) {
                    return _setup.emit("blur", _setup.model)
                  },
                  keyup: _setup.onKeyup,
                  input: _setup.triggerDebounce,
                  change: function ($event) {
                    var $$a = _setup.model,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_setup.model = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_setup.model = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _setup.model = $$c
                    }
                  },
                },
              })
            : _setup.computedType === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.model,
                    expression: "model",
                  },
                ],
                ref: "inputRef",
                staticClass: "form-control",
                class: _setup.computedClass,
                attrs: {
                  id: _vm.id,
                  name: _vm.name,
                  disabled: _vm.disabled,
                  placeholder: _vm.placeholder,
                  required: _vm.required,
                  minlength: _vm.minlength,
                  maxlength: _vm.maxlength,
                  step: _vm.step,
                  min: _vm.min,
                  max: _vm.max,
                  pattern: _vm.pattern,
                  type: "radio",
                },
                domProps: { checked: _vm._q(_setup.model, null) },
                on: {
                  blur: function ($event) {
                    return _setup.emit("blur", _setup.model)
                  },
                  keyup: _setup.onKeyup,
                  input: _setup.triggerDebounce,
                  change: function ($event) {
                    _setup.model = null
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.model,
                    expression: "model",
                  },
                ],
                ref: "inputRef",
                staticClass: "form-control",
                class: _setup.computedClass,
                attrs: {
                  id: _vm.id,
                  name: _vm.name,
                  disabled: _vm.disabled,
                  placeholder: _vm.placeholder,
                  required: _vm.required,
                  minlength: _vm.minlength,
                  maxlength: _vm.maxlength,
                  step: _vm.step,
                  min: _vm.min,
                  max: _vm.max,
                  pattern: _vm.pattern,
                  type: _setup.computedType,
                },
                domProps: { value: _setup.model },
                on: {
                  blur: function ($event) {
                    return _setup.emit("blur", _setup.model)
                  },
                  keyup: _setup.onKeyup,
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _setup.model = $event.target.value
                    },
                    _setup.triggerDebounce,
                  ],
                },
              }),
          _vm._v(" "),
          _setup.slot.append
            ? _c(
                "div",
                { staticClass: "input-group-append border" },
                [_vm._t("append")],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.error
        ? _c(_setup.CError, { attrs: { message: _vm.errorMsg } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }